<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li><a [routerLink]="'/'">Home</a></li>
    </ul>
  </div>
</div>
<div class="page-content page-frame overflow-y-auto">
  <div class="page-sheet w-full max-w-2xl mx-auto">
    <section class="bm-card bm-card-sm">
      <div class="bm-card-body">
        <h2 class="bm-card-title">Auswahl Empfänger</h2>
        <fieldset class="bm-fieldset">
          <label class="bm-fieldset-label">Laber</label>
          <select class="bm-select" [(ngModel)]="selectedWarehouse" (change)="selectFirstBin()">
            @for (wh of warehouses; track $index) {
              <option [ngValue]="wh">
                {{ wh.label }}
              </option>
            }
          </select>
          <label class="bm-fieldset-label">Lagerplatz</label>
          <select class="bm-select" [(ngModel)]="selectedBin">
            @for (bin of selectedWarehouse?.bins; track $index) {
              <option [ngValue]="bin">
                {{ bin.name }}
              </option>
            }
          </select>
        </fieldset>
      </div>
    </section>

    <div class="article-selection">
      <section class="bm-card bm-card-sm">
        <div class="bm-card-body">
          <h2 class="bm-card-title">Artikel auswählen</h2>

          <div role="tablist" class="bm-tabs bm-tabs-lift w-full">
            <a role="tab" class="bm-tab" [class.bm-tab-active]="selectedTab === 'as'" (click)="selectedTab = 'as'">
              Artikelsuche
            </a>
            @if (selectedTab === "as") {
              <div class="block bm-tab-content bg-base-100 border-base-300 p-3">
                <label class="bm-fieldset-label"> Multi-Suchbox </label>
                <div class="bm-join w-full">
                  <input
                    type="text"
                    class="bm-join-item bm-input grow"
                    [(ngModel)]="searchTermArticle"
                    (keyup.ENTER)="searchArticles(searchTermArticle)"
                  />
                  <button
                    class="bm-join-item bm-btn bm-btn-square"
                    (click)="searchArticles(searchTermArticle)"
                    [disabled]="articleSpinner"
                  >
                    @if (articleSpinner) {
                      <span class="bm-loading bm-loading-spinnet"></span>
                    } @else {
                      <fa-icon [icon]="['far', 'search']" />
                    }
                  </button>
                </div>
                @if (foundArticles) {
                  <div class="grid grid-cols-2 gap-4 max-h-[50vh] overflow-y-auto mt-4">
                    @for (article of foundArticles; track $index) {
                      <div
                        class="bm-stat shadow p-4 rounded"
                        [class.bg-warning]="article.location === 'CONSUMED'"
                        [class.text-warning-content]="article.location === 'CONSUMED'"
                      >
                        <div class="bm-stat-title">
                          <b>{{ article.rma }}</b> ({{ articleStatus(article) }})
                        </div>
                        <div class="bm-stat-desc">
                          {{ article.description }}
                        </div>
                        <div class="bm-stat-desc">
                          sn: {{ article.serial_number }}
                          @if (article.status === "CONSUMED") {
                            <span class="bm-badge bm-badge-sm bm-badge-error">verbaucht!</span>
                          }
                        </div>
                        @if (!isArticleSelected(article) && !(article.location === "CONSUMED")) {
                          <div class="bm-stat-actions">
                            <button class="bm-btn bm-btn-xs" (click)="selectArticle(article)">
                              <fa-icon [icon]="['far', 'plus']" /> Auswählen
                            </button>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }

            <a role="tab" class="bm-tab" [class.bm-tab-active]="selectedTab === 'ls'" (click)="selectedTab = 'ls'">
              Lieferscheinsuche
            </a>
            @if (selectedTab === "ls") {
              <div class="block bm-tab-content bg-base-100 border-base-300 p-3">
                <label class="bm-fieldset-label"> Lieferschein suchen </label>
                <div class="bm-join w-full">
                  <input
                    type="text"
                    class="bm-join-item bm-input grow"
                    [(ngModel)]="searchTermDeliveryNote"
                    (keyup.ENTER)="searchDeliveryNote(searchTermDeliveryNote)"
                  />
                  <button
                    class="bm-join-item bm-btn bm-btn-square"
                    (click)="searchDeliveryNote(searchTermDeliveryNote)"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>
                @if (foundDeliveryNote) {
                  <div class="grid grid-cols-2 gap-4 max-h-[50vh] overflow-y-auto mt-4">
                    @for (article of foundDeliveryNote.articles; track $index) {
                      <div
                        class="bm-stat shadow p-4 rounded"
                        [ngClass]="{
                          differentWarehouse: hasDifferentWarehouse(article, foundDeliveryNote),
                          used: !hasDifferentWarehouse(article, foundDeliveryNote) && article.location === 'CONSUMED',
                        }"
                      >
                        <div class="bm-stat-title">
                          <b>{{ article.rma }}</b> ({{ articleStatus(article) }})
                        </div>
                        <div class="bm-stat-desc">
                          {{ article.description }}
                        </div>
                        <div class="bm-stat-desc">
                          sn: {{ article.serial_number }}
                          @if (article.status === "CONSUMED") {
                            <span class="bm-badge bm-badge-sm bm-badge-error">verbaucht!</span>
                          }
                        </div>
                        @if (hasDifferentWarehouse(article, foundDeliveryNote)) {
                          <div class="bm-stat-desc">
                            <b>nicht möglich, bereits umgebucht!</b>
                          </div>
                        }
                        @if (!isArticleSelected(article) && !hasDifferentWarehouse(article, foundDeliveryNote)) {
                          <div class="bm-stat-actions">
                            <button class="bm-btn bm-btn-xs" (click)="selectArticle(article)">
                              <fa-icon [icon]="['far', 'plus']" /> Auswählen
                            </button>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </section>
      @if (selectedArticles) {
        <section class="bm-card bm-card-sm">
          <div class="bm-card-body">
            <h3 class="bm-card-title">Ausgewählte Artikel</h3>
            <div class="grid grid-cols-2 gap-4 max-h-[50vh] overflow-y-auto mt-4">
              @for (article of selectedArticles; track $index) {
                <div class="bm-stat shadow p-4 rounded">
                  <div class="bm-stat-title">
                    <b>{{ article.rma }}</b> ({{ articleStatus(article) }})
                  </div>
                  <div class="bm-stat-desc">
                    {{ article.description }}
                  </div>
                  <div class="bm-stat-desc">
                    sn: {{ article.serial_number }}
                    @if (article.status === "CONSUMED") {
                      <span class="bm-badge bm-badge-sm bm-badge-error">verbaucht!</span>
                    }
                  </div>
                  @if (isArticleSelected(article)) {
                    <div class="bm-stat-actions">
                      <button class="bm-btn bm-btn-xs" (click)="unselectArticle(article)">
                        <fa-icon [icon]="['far', 'minus']" /> Entfernen
                      </button>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </section>
      }
    </div>

    <section class="bm-card bm-card-sm">
      <div class="bm-card-body">
        <h2 class="bm-card-title">Ausgabe</h2>

        @if (hasCreatedDeliveryNotes()) {
          <p><b>erzeugte Lieferscheine:</b><br /></p>
          <table class="bm-table bm-table-xs">
            <tr>
              <th></th>
              <th></th>
            </tr>
            @for (deliveryNote of createdDeliveryNotes; track $index) {
              <td>
                <a class="bm-link bm-link-hover" [routerLink]="['/', 'lieferscheine', deliveryNote.id]" target="_new">
                  <fa-icon [icon]="['far', 'truck']"></fa-icon> {{ deliveryNote.number }}
                </a>
              </td>
              <td>
                <a
                  class="bm-link bm-link-hover"
                  href="/r/api/v1/delivery_notes/{{ deliveryNote.id }}/label.pdf"
                  target="_new"
                >
                  <fa-icon [icon]="['far', 'print']"></fa-icon> Ettiketten drucken
                </a>
              </td>
            }
          </table>
        } @else {
          <button class="bm-btn" (click)="splitArticles()">Lieferscheine erzeugen</button>
        }
      </div>
    </section>
  </div>
</div>
